/**
 * Contenu du bouton d'aide. La FAQ est un premier jet, à compléter par l'équipe IT ;
 * le manuel d'utilisation se dépose dans frontend/public sous ce nom.
 */
export const MANUAL_URL = "/manuel-utilisation.pdf";

export const FAQ: Array<{ question: string; answer: string }> = [
  {
    question: "Que montrent les cartes du tableau de bord ?",
    answer:
      "Le montant à payer aux prestataires, le facturé et les économies sur la période choisie en haut à droite. Le prestataire sélectionné sur la première carte filtre aussi le circuit des factures.",
  },
  {
    question: "Que signifient les statuts d'une facture ?",
    answer:
      "Soumise : reçue, pas encore prise en charge. En cours de traitement : contrôle médical ou contrôle Sinistre. Validée : traitement terminé, la note de paiement est disponible. Rejetée : refusée par l'Audit.",
  },
  {
    question: "Quelle différence entre la note de paiement et le décompte ?",
    answer:
      "La note de paiement récapitule ce que l'assureur doit payer au prestataire pour une facture. Le décompte récapitule, par entreprise et par lot, ce que l'assureur envoie à l'entreprise pour le paiement des prestataires.",
  },
  {
    question: "Comment le package d'un agent est-il choisi ?",
    answer:
      "Si l'entreprise n'a qu'un package autorisé, il s'applique à tous ses agents. Sinon, il se choisit sur la fiche de l'entreprise, dans la colonne Package. Les ayants droit suivent le package de l'agent.",
  },
  {
    question: "Pourquoi une demande de validation est-elle réservée au médecin en chef ?",
    answer:
      "Quand le bénéficiaire a consommé 90 % de son plafond annuel, seul le médecin en chef peut approuver, rejeter ou mettre en attente sa demande. Une demande ne peut pas être approuvée au-delà du reste annuel.",
  },
  {
    question: "Comment exporter un tableau ?",
    answer: "Utilisez les boutons PDF et Excel au-dessus du tableau. L'export reprend les lignes affichées avec les filtres en cours.",
  },
  {
    question: "Comment signaler un problème ?",
    answer:
      "Ouvrez l'onglet « Plainte / requête » de cette aide. Votre message part aux administrateurs ; leur réponse apparaît ici et dans vos notifications.",
  },
];
